import React from 'react';
import {
  FDAlert, FDBodyText, FDClickableText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';

const Details = ({
  base, prompt, href, onClick,
}) => {
  const [before, after] = base.split('{{prompt}}');

  return (
    <FDBodyText
      size={'sm'}
      value={
        <span>{before}<FDClickableText
          {...dataAttrs('alert-clickable-text-btn')}
          appearance={'standalone'}
          href={href}
          onClick={onClick}
          label={prompt}
        />{after}
        </span>
      }
    />
  );
};

Details.defaultProps = {
  prompt: undefined,
  onClick: undefined,
  href: undefined,
};

Details.propTypes = {
  base: PropTypes.string.isRequired,
  prompt: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
};

export const AlertRel = ({
  relationship, status, onClick, href,
}) => {
  if (!onClick && !href) {
    throw new Error('Developer config: Must provide at least one of onClick or href');
  }

  return (
    <FDAlert
      status={status}
      title={relationship.meta('title')}
      description={<Details
        color={status}
        base={relationship.meta('description')}
        prompt={relationship.meta('prompt')}
        onClick={() => onClick(relationship)}
        href={href}
      />}
    />
  );
};


AlertRel.defaultProps = {
  onClick: undefined,
  href: undefined,
  status: 'info',
};

AlertRel.propTypes = {
  relationship: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  href: PropTypes.string,
  status: PropTypes.string,
};
